module.exports = __webpack_public_path__ + "img/order.7da9f32c.png";